import * as types from './mutation_types';
import {API_ENTRYPOINT} from "../../../config/entrypoint";
import fetch from "../../../utils/fetch";

export const reset = ({ commit }) => {
  commit(types.DASHBOARD_RESET);
};

export const loadOverview = ({commit, dispatch}, obj) => {
  commit(types.DASHBOARD_SET_LOADING, true);
  const url = new URL("api/trainers", API_ENTRYPOINT);

  url.searchParams.set("itemsPerPage",obj.itemsPerPage);
  url.searchParams.set("page",obj.page);
  url.searchParams.set("groups",'trainer-overview');
  // OR mezi kategoriemi (player/regular/league/rocket/stadium), viz
  // TrainerCategoryFilter.php - prazdne pole = bez filtru (vsichni)
  (obj.categories || []).forEach((category) => {
    url.searchParams.append("category[]", category);
  });
  if (obj.order) {
    url.searchParams.set('order['+obj.order+']', obj.asc ? 'asc' : 'desc');
  }

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.DASHBOARD_SET_LOADING, false);
      commit(types.DASHBOARD_SET_ITEMS, data['member']);
      return data['hydra:totalItems'];
    })
    .catch((e) => {
      commit(types.DASHBOARD_SET_LOADING, false);
      commit(types.DASHBOARD_SET_ERROR, e.message);
    });
};

export const loadItems = ({commit, dispatch}) => {
  commit(types.DASHBOARD_SET_LOADING, true);
  const url = new URL("api/trainers", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.DASHBOARD_SET_LOADING, false);
      commit(types.DASHBOARD_SET_ITEMS, data['member']);
    })
    .catch((e) => {
      commit(types.DASHBOARD_SET_LOADING, false);
      commit(types.DASHBOARD_SET_ERROR, e.message);
    });
};

export const loadTypeTable = ({commit, dispatch}) => {
  commit(types.DASHBOARD_SET_LOADING, true);
  const url = new URL("api/get-type-table", API_ENTRYPOINT);

  return fetch(url, {dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.DASHBOARD_SET_LOADING, false);
      return data
    })
    .catch((e) => {
      commit(types.DASHBOARD_SET_LOADING, false);
      commit(types.DASHBOARD_SET_ERROR, e.message);
    });
};

export const fetchObject = ({commit, dispatch},obj) => {
  commit(types.DASHBOARD_SET_LOADING, true);

  if (obj.method === 'GET'){
    return fetch(obj.url, {dispatch: dispatch})
      .then((response) => response.json())
      .then((data) => {
        commit(types.DASHBOARD_SET_LOADING, false);
        return data;
      })
      .catch((e) => {
        commit(types.DASHBOARD_SET_LOADING, false);
        commit(types.DASHBOARD_SET_ERROR, e.message);
      });
  }
  // OTHER
  return fetch(obj.url, {method: obj.method, body: JSON.stringify(obj.obj), dispatch: dispatch})
    .then((response) => response.json())
    .then((data) => {
      commit(types.DASHBOARD_SET_LOADING, false);
      return data;
    })
    .catch((e) => {
      commit(types.DASHBOARD_SET_LOADING, false);
      commit(types.DASHBOARD_SET_ERROR, e.message);
    });
};
